export default __webpack_public_path__ + "locales/sl/PDFFormDialog.json?hash=614498a818e4564814e320206da1b9b5";